import { Navigate, useLocation } from "react-router-dom";
interface Props {
  // the path inside the merged Unifier module the old route now lives at
  to: string;
  // forced tab index, for the three routes that used to be separate screens
  tab?: number;
}
/**
 * Keeps bookmarks and links to the pre-merge Unifier routes
 * (unifier_maps / calculation_types / unique_definitions) working by sending
 * them to the matching tab or sub-page, query parameters included.
 */
const LegacyUnifierRedirect = ({ to, tab }: Props) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  if (tab !== undefined) {
    params.set("tab", String(tab));
  }
  const query = params.toString();
  return <Navigate to={query ? `${to}?${query}` : to} replace />;
};

export default LegacyUnifierRedirect;
